import React from 'react';
import { motion } from 'framer-motion';
import { Phone } from 'lucide-react';
import { content } from '../data/content';
export function FinalCTA() {
  return <section id="contact" className="relative py-24 md:py-32 overflow-hidden" data-id="element-30">
      {/* Deep Sunset Background */}
      <div className="absolute inset-0 flex flex-col" data-id="element-31">
        <div className="flex-1 bg-brand-brown" data-id="element-32" />
        <div className="flex-1 bg-[#35120d]" data-id="element-33" />
        <div className="flex-1 bg-[#2b0e0a]" data-id="element-34" />
        <div className="flex-1 bg-[#210a08]" data-id="element-35" />
      </div>

      {/* Top Accent Line */}
      <div className="absolute top-0 left-0 w-full h-2 bg-brand-orange" data-id="element-36" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-37">
        <div className="flex flex-col lg:flex-row gap-16 items-center" data-id="element-38">
          {/* Text Content */}
          <div className="lg:w-1/2 text-center lg:text-left" data-id="element-39">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="font-display text-4xl md:text-5xl lg:text-6xl font-bold text-brand-cream mb-6" data-id="element-40">
              {content.contact.heading}
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="text-xl text-brand-cream/80 mb-12" data-id="element-41">
              {content.contact.subhead}
            </motion.p>

            <motion.div initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} data-id="element-42">
              <a href={`tel:${content.company.phone.replace(/[^0-9]/g, '')}`} className="inline-flex items-center text-2xl md:text-3xl font-display font-bold text-brand-amber hover:text-brand-orange transition-colors" data-id="element-43">
                <Phone className="w-8 h-8 mr-4" data-id="element-44" />
                Or call us at {content.company.phone}
              </a>
            </motion.div>
          </div>

          {/* Form */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="lg:w-1/2 w-full max-w-md lg:max-w-none mx-auto" data-id="element-45">
            <div className="bg-brand-cream rounded-2xl p-8 shadow-2xl" data-id="element-46">
              <form className="space-y-6" onSubmit={e => e.preventDefault()} data-id="element-47">
                <div data-id="element-48">
                  <label htmlFor="name" className="block text-sm font-medium text-brand-brown mb-1" data-id="element-49">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full px-4 py-3 min-h-[44px] rounded border border-brand-tan/30 focus:border-brand-orange focus:ring-1 focus:ring-brand-orange outline-none transition-all bg-white" placeholder="Your Full Name" data-id="element-50" />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-51">
                  <div data-id="element-52">
                    <label htmlFor="phone" className="block text-sm font-medium text-brand-brown mb-1" data-id="element-53">
                      Phone
                    </label>
                    <input type="tel" id="phone" className="w-full px-4 py-3 min-h-[44px] rounded border border-brand-tan/30 focus:border-brand-orange focus:ring-1 focus:ring-brand-orange outline-none transition-all bg-white" placeholder="(480) 555-0123" data-id="element-54" />
                  </div>
                  <div data-id="element-55">
                    <label htmlFor="email" className="block text-sm font-medium text-brand-brown mb-1" data-id="element-56">
                      Email
                    </label>
                    <input type="email" id="email" className="w-full px-4 py-3 min-h-[44px] rounded border border-brand-tan/30 focus:border-brand-orange focus:ring-1 focus:ring-brand-orange outline-none transition-all bg-white" placeholder="you@example.com" data-id="element-57" />
                  </div>
                </div>

                <div data-id="element-58">
                  <label htmlFor="address" className="block text-sm font-medium text-brand-brown mb-1" data-id="element-59">
                    Address
                  </label>
                  <input type="text" id="address" className="w-full px-4 py-3 min-h-[44px] rounded border border-brand-tan/30 focus:border-brand-orange focus:ring-1 focus:ring-brand-orange outline-none transition-all bg-white" placeholder="Street Address, City, Zip" data-id="element-60" />
                </div>

                <div data-id="element-61">
                  <label htmlFor="service" className="block text-sm font-medium text-brand-brown mb-1" data-id="element-62">
                    Service Needed
                  </label>
                  <select id="service" className="w-full px-4 py-3 min-h-[44px] rounded border border-brand-tan/30 focus:border-brand-orange focus:ring-1 focus:ring-brand-orange outline-none transition-all bg-white text-brand-brown" data-id="element-63">
                    <option value="" disabled selected data-id="element-64">
                      Select a service...
                    </option>
                    {content.contact.services.map((service, idx) => <option key={idx} value={service} data-id="element-65">
                        {service}
                      </option>)}
                  </select>
                </div>

                <button type="submit" className="w-full bg-brand-orange text-brand-cream font-bold text-lg py-4 rounded hover:bg-opacity-90 transition-all shadow-md min-h-[48px] mt-4" data-id="element-66">
                  Get My Free Estimate
                </button>
              </form>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}